import TrustpilotReviewStars from '@/common/components/TrustpilotReviews/TrustpilotReviewStars';
import { SimpleTrustPilot } from 'generatedBfw/static/models/SimpleTrustPilot';

import styles from './Referrals.module.scss';

interface TrustPilotProps {
  trustPilot: SimpleTrustPilot;
}

const ReferralsTrustpilot = ({ trustPilot }: TrustPilotProps) => {
  return (
    <div className={styles.trustpilotContainer}>
      <h3 className={styles.trustpilotHeading}>Trustpilot reviews</h3>
      <TrustpilotReviewStars starCount={trustPilot.trustScoreStars} />
    </div>
  );
};

export default ReferralsTrustpilot;
